import STORAGE_KEY from '../constants/storageKey';

export const getLoginDetailFromSession = () =>
  JSON.parse(localStorage.getItem(STORAGE_KEY.SESSION_DETAILS));

export const setLoginDetailInSession = (sessionDetails) => {
  localStorage.setItem(
    STORAGE_KEY.SESSION_DETAILS,
    JSON.stringify(sessionDetails)
  );
};

export const setPlanDetails = (details) => {
  const sessionDetails = getLoginDetailFromSession();

  // Create a shallow copy of details to avoid mutating the function parameter.
  const updatedDetails = { ...details };

  if (sessionDetails && sessionDetails.customPlan) {
    Object.keys(sessionDetails.customPlan).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(details, key)) {
        // Create a new object for the key to avoid direct mutation.
        updatedDetails[key] = {
          ...updatedDetails[key],
          value: sessionDetails.customPlan[key].value,
        };
      }
    });
  }

  localStorage.setItem(
    STORAGE_KEY.PRICE_PLAN_DETAILS,
    JSON.stringify(updatedDetails)
  );
};

export const getPlanDetails = () => {
  const UserPricePlanCache = JSON.parse(
    localStorage.getItem(STORAGE_KEY.PRICE_PLAN_DETAILS)
  );
  return UserPricePlanCache;
};

export const setCareerPath = (careerpath) => {
  sessionStorage.setItem(STORAGE_KEY.CAREER_PATH, JSON.stringify(careerpath));
};

export const getCareerPath = () => {
  const careerpath = JSON.parse(
    sessionStorage.getItem(STORAGE_KEY.CAREER_PATH)
  );
  return careerpath;
};
